import React from "react";
import { Button } from "../../../ecosystem";

export const CareGapsButtons = ({
    prev,
    next
}) => {

    return (
        <div className="row care-gaps-buttons-container">
            <div className="col-12 col-xl-9">
                <div className="row">
                    <div className="col-12 col-lg-8 col-xl-6">
                        <div className="row">
                            {!prev.hide &&
                                <div className="col-6">
                                    <Button
                                        fluid
                                        variant="secondary"
                                        icon="chevron-left"
                                        iconPosition="left"
                                        onClick={prev.onClick}>
                                        Previous
                                    </Button>
                                </div>
                            }
                            {!next.hide && 
                                <div className="col-6">
                                    <Button
                                        fluid
                                        disabled={next.disabled}
                                        icon={(next.icon || next.icon === '') ? next.icon : "chevron-right"}
                                        iconPosition="right"
                                        onClick={next.onClick}>
                                        {next.label ? next.label : "Next"}
                                    </Button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};